import { selectTab } from "@/state/functions";
import { RootState } from "@/state/reducer";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

const Complete  = () => {
   const State = useSelector((state: RootState) => state);
   const dispatch = useDispatch();


 
    return(
    <div className="page greeting gridCenter w100 h100">
       <div className="inner columnCenter gap24">
          <h1>Большое спасибо!</h1>
          <div className="">
             Сообщите куратору о завершении
          </div>
       </div>
    </div>)
}

export default Complete;